import { ICON_TYPES } from './iconTypes';

export default {
	bold: {
		name: 'bold',
		type: ICON_TYPES.fontAwesome,
		text: 'Bold',
	},
	italic: {
		name: 'italic',
		type: ICON_TYPES.fontAwesome,
		text: 'Italic',
	},
	underline: {
		name: 'underline',
		type: ICON_TYPES.fontAwesome,
		text: 'Underline',
	},
	bulletPoints: {
		name: 'format-list-bulleted',
		type: ICON_TYPES.materialCommunityIcons,
		text: 'Bullet Points',
	},
	numberedList: {
		name: 'format-list-numbered',
		type: ICON_TYPES.materialCommunityIcons,
		text: 'Numbered List',
	},
	alignLeft: {
		name: 'format-align-left',
		type: ICON_TYPES.materialCommunityIcons,
		text: 'Align Left',
	},
	alignRight: {
		name: 'format-align-right',
		type: ICON_TYPES.materialCommunityIcons,
		text: 'Align Right',
	},
	alignCenter: {
		name: 'format-align-center',
		type: ICON_TYPES.materialCommunityIcons,
		text: 'Align Center',
	},
};